import React from 'react'
// import TestImg from './TestImg'
import RandVar from './RandVar'
import "./sketch.css"

const SketchImage = () => {
  return (
    <div>
      {/* <TestImg /> */}
      <RandVar />
    </div>
    )
  }

  export default SketchImage